const date = new Intl.DateTimeFormat('en-ZA', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  timeZone: 'Africa/Johannesburg',
});
const dateTime = new Intl.DateTimeFormat('en-ZA', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
  timeZone: 'Africa/Johannesburg',
});

/** Date-only business values stay on their original calendar day. */
export function formatDate(value: string | null): string {
  if (value === null) return 'Not set';
  const parsed = new Date(/^\d{4}-\d{2}-\d{2}$/.test(value) ? `${value}T12:00:00Z` : value);
  return Number.isFinite(parsed.getTime()) ? date.format(parsed) : 'Date unavailable';
}
export function formatDateTime(value: string): string {
  const parsed = new Date(value);
  return Number.isFinite(parsed.getTime()) ? `${dateTime.format(parsed)} SAST` : 'Date unavailable';
}
export function readableCode(value: string): string {
  return value
    .toLowerCase()
    .replaceAll('_', ' ')
    .replace(/^./, (letter) => letter.toUpperCase());
}
/** Display-only identity: never changes the stored profile or invents a full name. */
export function displayPersonName(name: string): string {
  const value = name.trim();
  if (!value) return 'Team member';
  if (value !== value.toLocaleLowerCase('en-ZA')) return value;
  return value.replace(
    /(^|[\s.-])(\p{L})/gu,
    (_, separator: string, letter: string) => `${separator}${letter.toLocaleUpperCase('en-ZA')}`,
  );
}
